import { makeStyles } from '@mui/styles'
import { paidConsumerDesktopNavHeight, paidConsumerMobileNavHeight } from '../style'

export const trialBannerHeight = 56

export const useStyles = makeStyles(({ spacing, palette, breakpoints, shadows }) => ({
  // Desktop Navigation
  desktopNav: {
    display: 'flex',
    flexDirection: 'column',
    width: '100%',
    padding: `${spacing(1)} ${spacing(10)} ${spacing(1)} ${spacing(10)}`,
    height: paidConsumerDesktopNavHeight
  },
  topSection: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    position: 'relative',
    justifyContent: 'flex-end',
    paddingBottom: spacing(1),
    borderBottom: '1px solid #5D5BED'
  },
  logoCenter: {
    position: 'absolute',
    left: '50%',
    transform: 'translateX(-50%)',
    display: 'flex',
    alignItems: 'center'
  },
  bottomSection: {
    display: 'flex',
    alignItems: 'center',
    width: '100%',
    justifyContent: 'space-between',
    paddingTop: spacing(1),
    // Allow children to shrink properly within flex
    minWidth: 0
  },
  navSection: {
    display: 'flex',
    alignItems: 'center',
    flex: '1 1 auto'
  },
  rightSection: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    // Make search area shrinkable to prevent overflow on mid-width screens
    flex: '0 1 38%',
    [breakpoints.down('lg')]: {
      flex: '0 1 34%'
    },
    [breakpoints.down('md')]: {
      flex: '0 1 30%'
    }
  },

  profileButton: {
    color: palette.text.primary,
    width: 36,
    height: 36,
    '&:hover': {
      backgroundColor: palette.primary.light
    }
  },

  // Mobile Navigation
  mobileNav: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'space-between',
    width: '100%',
    height: paidConsumerMobileNavHeight,
    position: 'relative',
    padding: `${spacing(2)} ${spacing(2)}`
  },
  mobileMenuButton: {
    color: palette.text.primary
  },
  mobileActions: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(0.5)
  },
  mobileActionButton: {
    color: palette.text.primary,
    width: 40,
    height: 40
  },
  mobileSearchExpanded: {
    position: 'absolute',
    top: '100%',
    left: 0,
    right: 0,
    width: '100%',
    backgroundColor: `${palette.common.white} !important`,
    zIndex: 1300,
    boxShadow: shadows[2],
    // Ensure it doesn't interfere with search suggestions
    overflow: 'visible'
  },
  mobileSearchHeader: {
    display: 'flex',
    alignItems: 'center',
    padding: spacing(2),
    gap: spacing(2)
  },
  mobileSearchContainer: {
    flex: 1,
    cursor: 'text'
  },
  trialBanner: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    padding: `${spacing(1)}`,
    backgroundColor: palette.primary.main,
    color: palette.common.white,
    height: trialBannerHeight,
    position: 'relative',
    // Reserve space for close button on mobile/tablet
    [breakpoints.down('lg')]: {
      paddingRight: spacing(6)
    }
  },
  centeredContent: {
    display: 'flex',
    alignItems: 'center',
    gap: spacing(2)
  },
  closeButton: {
    color: palette.common.white,
    position: 'absolute',
    right: spacing(2),
    '&:hover': {
      backgroundColor: 'rgba(255, 255, 255, 0.1)'
    }
  }
}))
